import React, {ReactElement} from 'react';
import MedopsLogo from '@components/system/MyIcons/MedopsLogo';
import SignInPageLogo from '@components/system/MyIcons/SignInPageLogo';
import {makeStyles, createStyles, Theme} from '@material-ui/core';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    whiteLogo: {
      paddingBottom: '40px',
      margin: '5% 0 0 5%'
    },
    polygon: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      clipPath: 'polygon(50% 0%, 100% 50%,50% 100%, 0% 50%)',
      background: '#4182edeb',
      margin: '-17% 0 10% 2%'
    },
    signInPageLogo: {
      display: 'flex',
      flexDirection: 'column',
      width: '50%',
      justifyContent: 'center',
      backgroundColor: '#2877fafa',
      '@media (min-width: 0px) and (max-width: 1023px)': {
        display: 'none'
      }
    }
  })
);
const LogoIcon = (): ReactElement => {
  const classes = useStyles();
  const renderWhitePcareLogo = (): ReactElement => {
    return (
      <div className={classes.whiteLogo}>
        <MedopsLogo color={'white'} style={{width: '30%'}} />
      </div>
    );
  };
  const PcareSignInLogo = (): ReactElement => {
    return (
      <div className={classes.polygon}>
        <SignInPageLogo style={{margin: 'auto', width: '70%'}} />
      </div>
    );
  };

  return (
    <div className={classes.signInPageLogo}>
      {renderWhitePcareLogo()}
      {PcareSignInLogo()}
    </div>
  );
};

export default LogoIcon;
